const { REACT_APP_DEV_FAST_API_URL, REACT_APP_PROD_FAST_API_URL,REACT_APP_ENV } = process.env;

const getFastApiUrl = () => {
  const env = REACT_APP_ENV;
  if (env === "development") {
    return REACT_APP_DEV_FAST_API_URL;
  } else if (env === "production") {
    return REACT_APP_PROD_FAST_API_URL;
  } else {
    return "https://node01.haveto.com/";
  }
};

const FASTAPIURL = getFastApiUrl();

export default FASTAPIURL;
